<template>
  <img :src="hashedSrc" :alt="alt" v-if="src || media.type === 'photo'">
</template>

<script>
import sha1 from 'sha1';

const ratio = 0.7225; // width/height

export default {
  name: 'media',
  props: {
    media: {
      type: Object,
      default: () => ({}),
    },
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    computedWidth() {
      return this.width || Math.round(this.height * ratio);
    },
    computedHeight() {
      return this.height || Math.round(this.width / ratio);
    },
    computedSrc() {
      return this.src || this.media.url;
    },
    hashedSrc() {
      const filename = this.computedSrc.replace(/^.*[\\/]/, '');
      const hash = sha1(`media_content${this.computedWidth}${this.computedHeight}${filename}sportmaster404`).substring(0, 4);
      return this.computedSrc.replace('{width}', this.computedWidth).replace('{height}', this.computedHeight).replace('{hash}', hash);
    }
  }
}
</script>
